import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=24613b8a&scoped=true&"
import script from "./modal.js?vue&type=script&lang=js&"
export * from "./modal.js?vue&type=script&lang=js&"
import style0 from "./modal.scss?vue&type=style&index=0&id=24613b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24613b8a",
  null
  
)

export default component.exports